import React from 'react'
import { Helmet } from 'react-helmet';

const Acknowledgement = () => {
  return (
    <>
    <Helmet>
                <title>Acknowledgement | GeoID</title>
            </Helmet>
      <div className='main-container'>
        <div className="section-heading">
          <h1>Acknowledgement</h1>
        </div>
        <div className="section">
          <p className="para-content">We greatly acknowledge the National Register of Large Dams (NRLD) - 2019 data provided by the Central Water Commission of India (CWC), the data provided by Coupled Model Intercomparison Project 6 (CMIP6) and Indian Meteorological Department (IMD), Copernicus.

          </p>
          <p className="para-content">
            We appreciate the assistance by Anuj Prakash Kushwaha, Water and Climate Lab, IIT Gandhinagar in generating the streamflow data from the VIC model.
          </p>
        </div>
      </div>
    </>
  )
}

export default Acknowledgement
